<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'reserve:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'reserve:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-tooltip v-if="this.$fun.isQx(this.qx, 'reserve:export')" content="按查询条件导出Excel" effect="light">
      <el-button :loading="exportLoading1" type="info" icon="document" @click="exportExcel">导出Excel</el-button>
    </el-tooltip>
  </el-button-group>
  <div class="fun">
    <div class="search-div">
      <el-select v-model="searchState" filterable clearable placeholder="请选择当前状态" class="width">
        <el-option label="可预约" value=1 />
        <el-option label="已预约" value=2 />
        <el-option label="排队中" value=3 />
        <el-option label="完结" value=4 />
        <el-option label="取消" value=0 />
        <el-option label="货场取消" value=-1 />
      </el-select>
      <el-input placeholder="请输入关键字" prefix-icon="search" v-model="searchKey" clearable class="width"></el-input>
      <el-date-picker v-model="searchDate" size="small" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" :default-time="defaultTime" value-format="x" clearable class="width1"></el-date-picker>
      <el-button type="primary" icon="search" @click="getData">查询</el-button>
    </div>
    <STC colName="reserveColumn" :colList="colList" />
  </div>
  <!-- <el-row :gutter="2">
    <el-col :span="14"> -->
      <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
          :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" @current-change="handleCurrentRowChange"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column type="selection" width="40" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '预约日期')" prop="date" label="预约日期" width="110" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '序号')" prop="queue" label="序号" width="60" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '排队编号')" prop="sn" label="排队编号" width="90" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '当前状态')" prop="stateName" label="当前状态" width="100" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '货场')" prop="yard" label="货场" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '车辆')" prop="vehicle" label="车辆" />
        <el-table-column v-if="this.$fun.isExist(checkColList, '货物类型')" prop="cargoTypeName" label="货物类型" />
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-link type="primary" :underline="false" @click="viewInfo(scope.row.id)">查看</el-link>
            &nbsp;&nbsp;
            <el-link v-if="this.$fun.isQx(this.qx, 'reserve:edit') && (scope.row.state !== 0 && scope.row.state !== -1)" type="primary" :underline="false" @click="editInfo(scope.row.id)">修改</el-link>
            <!-- &nbsp;&nbsp;
            <el-link v-if="this.$fun.isQx(this.qx, 'reserve:flow') && scope.row.state > 1" type="primary" :underline="false" @click="flowInfo(scope.row.id)">流程</el-link> -->
          </template>
        </el-table-column>
      </el-table>
    <!-- </el-col>
    <el-col :span="10">
      <el-table v-loading="flowTableLoading" :data="flowTableData" highlight-current-row stripe border
          height="100%" style="width: 100%"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column prop="stepName" label="流程环节" width="100"></el-table-column>
        <el-table-column prop="stateName" label="状态" width="100"></el-table-column>
        <el-table-column prop="executor" label="执行人" width="120"></el-table-column>
        <el-table-column prop="execTime" label="执行时间"></el-table-column>
      </el-table>
    </el-col>
  </el-row> -->
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
   :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
   :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
  </el-pagination>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden"></el-input>
      <el-form-item label="预约日期" prop="date">
        <el-input v-model="form.date" class="width"></el-input>
      </el-form-item>
      <!-- <el-form-item label="预约日期" prop="date">
        <el-date-picker
          v-model="form.date"
          type="date"
          :disabled-date="disabledDate"
          placeholder="选择预约日期"
          value-format="YYYY-MM-DD" />
      </el-form-item> -->
      <el-form-item label="当前状态" prop="state">
        <el-radio-group v-model="form.state" @change="stateChange">
          <el-radio-button label="1">可预约</el-radio-button>
          <el-radio-button label="2">已预约</el-radio-button>
          <el-radio-button label="3">排队中</el-radio-button>
          <el-radio-button label="4">完结</el-radio-button>
          <el-radio-button label="0">取消预约</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.state === 0" label="取消原因" prop="cause" >
        <el-input v-model="form.cause" type="textarea" rows=5 maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="编号">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 查看场地预约信息 -->
  <el-dialog title="查看场地预约信息" v-model="dialogFormVisible1" :close-on-click-modal="false">
    <div class="viewinfo">
      <p>
        <label>序号</label>
        <span>{{view.queue}}</span>
      </p>
      <p>
        <label>排队号</label>
        <span>{{view.sn}}</span>
      </p>
      <p>
        <label>预约日期</label>
        <span>{{view.date}}</span>
      </p>
      <p>
        <label>当前状态</label>
        <span class="red">{{view.stateName}}</span>
      </p>
      <p>
        <label>货场名称</label>
        <span>{{view.yard}}</span>
      </p>
      <p>
        <label>车牌号</label>
        <span>{{view.vehicle}}</span>
      </p>
      <p>
        <label>货物类型</label>
        <span>{{view.cargoTypeName}}</span>
      </p>
      <p>
        <label>货物数量</label>
        <span>{{view.cargoNum}}</span>
      </p>
      <p>
        <label>预约/确认时间</label>
        <span class="red">{{view.confirmTime}}</span>
      </p>
      <p v-if="view.state === 0 || view.state === -1">
        <label>取消原因</label>
        <span>{{view.cause}}</span>
      </p>
      <p v-if="view.state === 0 || view.state === -1">
        <label>取消时间</label>
        <span>{{view.cancelTime}}</span>
      </p>
      <div v-if="flowTableData.length > 0" style="padding: 0 40px;">
        <p class="success">预约排队中的流程</p>
        <el-steps direction="vertical" finish-status="success">
          <el-step v-for="item in flowTableData" :key="item.id"
          :title="item.stepName"
          :description="item.stateName + '&nbsp;&nbsp;' + item.execTime + '&nbsp;&nbsp;' + item.executor"
          :status="item.state === 1 ? 'wait' : 'finish'"></el-step>
        </el-steps>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="this.dialogFormVisible1 = false">关 闭</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 查看预约流程信息 -->
  <el-dialog title="查看预约流程信息" v-model="dialogFormVisible2" :close-on-click-modal="false">
    <div class="viewinfo" style="height: 400px;">
      <el-steps direction="vertical" finish-status="success">
        <el-step v-for="item in flowTableData" :key="item.id"
        :title="item.stepName"
        :description="item.stateName + '&nbsp;&nbsp;' + item.execTime + '&nbsp;&nbsp;' + item.executor"
        :status="item.state === 1 ? 'wait' : 'finish'"></el-step>
      </el-steps>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="this.dialogFormVisible2 = false">关 闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import STC from '@/components/SelectTableColumn'
import { dateFormate } from '@/utils/datetime_utils'
export default {
  name: 'reserve',
  components: {
    STC
  },
  data () {
    return {
      qx: '',
      colList: ['预约日期', '序号', '排队编号', '当前状态', '货场', '车辆', '货物类型'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      isDel: true,
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        date: '',
        state: 1,
        cause: '',
        queue: 0
      },
      view: {
        date: '',
        state: 1,
        stateName: 1,
        confirmTime: '',
        sn: '',
        yard: '',
        vehicle: '',
        cargoTypeName: '',
        cargoNum: '',
        cause: '',
        queue: 0
      },
      rules: {
        date: [
          { required: true, message: '请选择预约日期', trigger: 'blur' }
        ]
      },
      searchState: '',
      searchKey: '',
      searchDate: '',
      flowTableLoading: false,
      flowTableData: [],
      dialogFormVisible1: false,
      dialogFormVisible2: false
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      this.isDel = true
      for (var i = 0; i < val.length; i++) {
        this.selectionIds += val[i].id + ','
        if (val[i].state > 1) {
          this.isDel = false
        }
      }
    },
    // 新当前行改变时触发
    // handleCurrentRowChange (val) {
    //   if (val !== undefined && val !== null) {
    //     var roleid = val.id
    //     this.getFlowData(roleid)
    //   }
    // },
    disabledDate (time) {
      // 减一天毫秒数
      return time.getTime() < (Date.now() - 86400000)
    },
    async getData () {
      this.tableLoading = true
      const params = '?key=' + this.searchKey + '&state=' + this.searchState + '&date=' + this.searchDate + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.reservelist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
        // console.log('this.tableData=', this.tableData)
      }
      this.tableLoading = false
    },
    async getFlowData (rid) {
      this.flowTableLoading = true
      const params = '?rid=' + rid
      const { data: ret } = await this.$http.get(this.$api.reserveflowlist + params)
      if (ret.status === 0) {
        this.flowTableData = ret.data
      }
      this.flowTableLoading = false
    },
    stateChange (val) {
      this.form.state = parseInt(val)
    },
    addInfo () {
      this.form.id = ''
      this.dialogTitle = '添加场地预约'
      this.dialogFormVisible = true
    },
    async editInfo (id) {
      this.dialogFormVisible = true
      const { data: ret } = await this.$http.get1(this.$api.reserveid + '/' + id)
      if (ret.status === 0 && ret.data !== null) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改场地预约'
      } else {
        this.$message.error(ret.message)
      }
    },
    async viewInfo (id) {
      this.dialogFormVisible1 = true
      const { data: ret } = await this.$http.get1(this.$api.reserveget + '?id=' + id)
      if (ret.status === 0 && ret.data !== null) {
        // console.log('ret.data=', ret.data)
        const obj = ret.data
        Object.keys(this.view).forEach(key => {
          this.view[key] = obj[key]
          // console.log(key, obj[key])
        })
        this.flowTableData = ret.data.reserveFlows
      } else {
        this.$message.error(ret.message)
      }
    },
    // async flowInfo (id) {
    //   this.dialogFormVisible2 = true
    //   const params = '?rid=' + id
    //   const { data: ret } = await this.$http.get(this.$api.reserveflowlist + params)
    //   if (ret.status === 0) {
    //     this.flowTableData = ret.data
    //     console.log('this.flowTableData=', this.flowTableData)
    //   }
    // },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          // console.log('this.form=', this.form)
          const { data: ret } = await this.$http.post(this.$api.reservesave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      if (!this.isDel) {
        this.$message.error('状态为确认预约或完成预约的预约信息不能删除。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.reservedel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async exportExcel () {
      this.exportLoading1 = true
      const params = '?key=' + this.searchKey + '&state=' + this.searchState + '&date=' + this.searchDate
      const res = await this.$http.down(this.$api.reserveexportexcel + params)
      console.log('exportExcel=', res)
      if (!res) {
        return
      }
      // const { data: ret } = await this.$http.get(this.$api.logexportexcel + params)
      if (res.status === 200) {
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        var fn = '预约' + dateFormate('yyyy-MM-dd') + '.xlsx'
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.download = fn
        link.href = url
        document.body.appendChild(link)
        link.click()
        this.$message.success('导出数据成功！文件名' + fn)
      } else {
        this.$message.error(res.statusText)
      }
      this.exportLoading1 = false
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 88 - 42 - 35
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>

</style>
